import React, {Fragment} from 'react';
import {Layout, NavLink, Identity, Flex, Breadcrumbs, Button, Route, Switch, Next} from 'components';
import {capitalize, config, usePages} from 'helpers';

export function Router() {
  const {title, prev, total, current} = usePages();
  return (
    <Fragment>
      <Layout.Title>{capitalize(config.identityModule)}</Layout.Title>
      <Layout.Topbar.Tabs>
        <NavLink to={`/${config.identityModule}/`}>{ capitalize(config.identityModule) }</NavLink>
      </Layout.Topbar.Tabs>
      <Identity.Sidebar />
      <main>
        <Layout.Header>
          <Flex>
            <div className="pull-left">
              <h1>{ title }</h1>
              <Breadcrumbs className="small-spacing">
                { capitalize(config.identityModule) }
                <b className='multi-line'>{ current } of { total }</b>
              </Breadcrumbs>
            </div>
            {prev &&
              <Button to={prev} className={['small', 'borderless']} icon="return">
                Back
              </Button>
            }
            <Next className={['primary', 'small']} rightIcon="arrow-right" />
          </Flex>
        </Layout.Header>
        <Switch>
          <Route exact path="*/values/" component={Identity.Values} />
          <Route exact path="*/values/ask-yourself/" component={Identity.AskYourself} />
          <Route exact path="*/values/living-your-values/" component={Identity.LivingYourValues} />
          <Route exact path="*/values/go-deeper/" component={Identity.ValuesGoDeeper} />
          <Route exact path="*/beliefs/" component={Identity.Beliefs} />
          <Route exact path="*/beliefs/inquiry-1/" component={Identity.BeliefsInquiry1} />
          <Route exact path="*/beliefs/inquiry-2/" component={Identity.BeliefsInquiry2} />
          <Route exact path="*/beliefs/inquiry-3/" component={Identity.BeliefsInquiry3} />
          <Route exact path="*/habits/" component={Identity.Habits} />
          <Route exact path="*/habits/inquiry-1/" component={Identity.HabitsInquiry1} />
          <Route exact path="*/habits/go-deeper/" component={Identity.HabitsGoDeeper} />
          <Route exact path="*/strengths/" component={Identity.Strengths} />
          <Route exact path="*/strengths/inquiry-1/" component={Identity.StrengthsInquiry1} />
          <Route exact path="*/strengths/inquiry-2/" component={Identity.StrengthsInquiry2} />
          <Route exact path="*/strengths/summary/" component={Identity.StrengthsSummary} />
          <Route exact path="*/strengths/go-deeper/" component={Identity.StrengthsGoDeeper} />
          <Route exact path="*/passion/" component={Identity.Passion} />
          <Route exact path="*/passion/inquiry-1/" component={Identity.PassionInquiry1} />
          <Route exact path="*/passion/inquiry-2/" component={Identity.PassionInquiry2} />
          <Route exact path="*/passion/go-deeper/" component={Identity.PassionGoDeeper} />
          <Route exact path="*/passion/summary/" component={Identity.PassionSummary} />
          <Route exact path="*/purpose/" component={Identity.Purpose} />
          <Route exact path="*/purpose/inquiry-1/" component={Identity.PurposeInquiry1} />
          <Route exact path="*/purpose/go-deeper/" component={Identity.PurposeGoDeeper} />
          <Route exact path="*/dreams/" component={Identity.Dreams} />
          <Route exact path="*/dreams/inquiry-1/" component={Identity.DreamsInquiry1} />
          <Route exact path="*/dreams/inquiry-2/" component={Identity.DreamsInquiry2} />
          <Route exact path="*/vision/" component={Identity.Vision} />
          <Route exact path="*/vision/my-life/" component={Identity.VisionMyLife} />
          <Route exact path="*/vision/my-vision-and-me/" component={Identity.VisionAndMe} />
          <Route component={Identity.Intro} />
        </Switch>
      </main>
    </Fragment>
  );
}
